import { render, staticRenderFns } from "./exchange-bulk-list-type.vue?vue&type=template&id=d975ae3e&scoped=true&"
import script from "./exchange-bulk-list-type.vue?vue&type=script&lang=js&"
export * from "./exchange-bulk-list-type.vue?vue&type=script&lang=js&"
import style0 from "./exchange-bulk-list-type.vue?vue&type=style&index=0&id=d975ae3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d975ae3e",
  null
  
)

export default component.exports